import React from 'react';
import { Badge, Box, Text, Tooltip, Group } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import type { EntityRegistryEntry } from '../types';
import { getWorkflowActivityWarnings } from '../../validation/workflowActivityValidation';

export const workflowActivityConfig: EntityRegistryEntry = {
    hideIdInStandard: true,
    fetchAttributes: ['Id', 'DisplayName', 'EntityType', 'Action', 'Authorization', 'Request'],
    editor: 'workflowStep',
    listColumns: () => [
        {
            key: 'type',
            label: 'Type',
            sortable: false,
            render: (entity: any) => {
                const normBool = (v: any): boolean => typeof v === 'boolean' ? v : (typeof v === 'string' ? v.toLowerCase() === 'true' : false);
                const action = normBool(entity.Action);
                const authorization = normBool(entity.Authorization);
                const request = normBool(entity.Request);
                const none = !action && !authorization && !request;
                return (
                    <Group gap={4} align="center" wrap="wrap">
                        {action && <Badge variant="light" size="sm" color="orange">Action</Badge>}
                        {authorization && <Badge variant="light" size="sm" color="blue">Authorization</Badge>}
                        {request && <Badge variant="light" size="sm" color="violet">Request</Badge>}
                        {none && (
                            <>
                                <Text size="sm" c="dimmed">None</Text>
                                <Tooltip label="At least one of Action, Authorization, or Request must be true">
                                    <Box component="span" display="inline-flex">
                                        <IconAlertCircle size={18} color="var(--mantine-color-red-6)" />
                                    </Box>
                                </Tooltip>
                            </>
                        )}
                    </Group>
                );
            }
        }
    ],
    getWarnings: (data) => getWorkflowActivityWarnings(data),
};
